<script setup>
import { computed, onBeforeMount, ref } from 'vue';
import OfLogin from './components/OfLogin.vue';
import OfNavbarLeft from './components/navigation/OfNavbarLeft.vue';
import OfNavbarTop from './components/navigation/OfNavbarTop.vue';
import { user, merchant } from './store';
import requests, { onboardingToken } from '@dk.onlinefundraising/onboarding-utils/src/OfOnboardingRequests';
import OfMerchantView from './components/OfMerchantView.vue';
import OfEngageCampaign from './components/OfEngageCampaign.vue';
import OfUserList from './components/OfUserList.vue';
import OfProfile from './components/OfProfile.vue';
import { agencyMode, currentPage, agentScopes } from '@dk.onlinefundraising/onboarding-utils/src/pageHandler';
import { userAllowed } from './functions';
import OfOnboardingResult from './components/OfOnboardingResult.vue';
import { toaster } from "@dk.onlinefundraising/vue-utils/src/helpers/OfToaster";

const loggedIn = ref(true);
const NavbarLeft = ref(null);

/**
 * Get authToken from browser session
*/
function ensureToken() {

  const nowInSeconds = Math.round(new Date().getTime() / 1000);

  let authExp = localStorage.getItem('authExp');
  if (authExp && nowInSeconds > authExp) {

    //  this.logOut();
    window.console.log("login expired");

    return false;
  } else {
    return true;
  }
}
function handleLoggedIn() {

  if (ensureToken()) {

    const authToken = localStorage.getItem('authToken');

    if (authToken) {

      requests.getAccount(authToken).then((result) => {
        if (result) {

          const merchantId = new URLSearchParams(window.location.search).get('merchantId')

          user.value.authToken = authToken;
          user.value.guid = result.userGuid;
          user.value.agencyId = result.agencyId;
          user.value.merchantId = result.merchantId;
          user.value.role = result.role;
          user.value.name = result.name;
          user.value.email = result.email;
          user.value.externalId = result.externalId;
          user.value.scopes = result.scopes;
          agentScopes.value = result.scopes;

          if (['AgencyManager', 'SeniorAgent'].includes(result.role)) {
            agentScopes.value.push('READ_CONTACT_DATA') // TODO Remove when done propperly in backend.
          }

          onboardingToken.value = authToken;

          sessionStorage.setItem('agencyId', result.agencyId);

          loggedIn.value = true;

          if (merchantId) {

            requests.getMerchant(merchantId, user.value.agencyId).then((merchantResult) => {
              if (merchantResult) {
                merchant.value = merchantResult;
              }
            });

            sessionStorage.setItem('merchantId', merchantId);

          }
        } else {
          localStorage.removeItem('authToken');
          localStorage.removeItem('authExp');
          toaster.error('Login expired');
          loggedIn.value = false;
        }

      })
    } else {
      loggedIn.value = false;
    }
  } else {
    loggedIn.value = false;
  }
}
function logout() {

  user.value.authToken = null;
  user.value.guid = null;
  user.value.agencyId = null;
  user.value.merchantId = null;
  user.value.role = null;
  user.value.name = null;
  user.value.email = null;
  user.value.externalId = null;
  user.value.scopes = null;
  agentScopes.value = null;

  onboardingToken.value = null;

  merchant.value = null;

  sessionStorage.removeItem('merchantId');
  sessionStorage.removeItem('agencyId');
  localStorage.removeItem('authToken');
  localStorage.removeItem('authExp');

  loggedIn.value = false;

  window.location = '/';
}

onBeforeMount(() => {

  agencyMode.value = true;

  handleLoggedIn()

})
const onboardResult = computed(() => {
  const path = window.location.pathname;
  const parts = path.split('/');
  const index = parts.indexOf("result");
  return (index > -1);
})
const onboardMode = computed(() => {
  const path = window.location.pathname;
  const parts = path.split('/');
  const index = parts.indexOf("onboard");
  return (index > -1);
})

document.addEventListener("wheel", function(){
    if(document.activeElement.type === "number"){
        document.activeElement.blur();
    }
});

// Call the function once the component is mounted
</script>
<template>
  <OfOnboardingResult v-if="onboardResult" />
  
  <OfLogin v-else-if="!loggedIn" @logged-in="handleLoggedIn" />

  <template v-else-if="user.authToken && loggedIn">

    <div v-if="!onboardMode" class="agency">

      <div id="nav-left">
        <OfNavbarLeft ref="NavbarLeft" @logout="logout" />
      </div>

      <div id="nav-top">
        <OfNavbarTop @get-merchants="NavbarLeft.getMerchants()" />
      </div>

      <div class="content">
        <OfMerchantView v-if="merchant.merchantId" />

        <OfUserList v-else-if="currentPage == 'users' && userAllowed('READ_USER')" />

        <OfProfile v-else-if="currentPage == 'profile'" />

        <div v-else>
          <h2>Welcome {{ user.name }}</h2>
          <p>Please select a client on the left</p>
        </div>
      </div>

    </div>

    <template v-else-if="onboardMode">
      <OfEngageCampaign />
    </template>

  </template>

</template>
<style scoped>
.agency {
  display: grid;
  grid-template-columns: 210px auto;
  grid-template-rows: 72px auto;
  grid-template-areas:
    "left top"
    "left content"
}

#nav-left {
  background: #212121;
  grid-area: left;
  position: relative;
}

.nav-top {
  position: sticky;
  top: 0;
  grid-area: top;
  z-index: 900;
}

.content {
  grid-area: content;
  padding: 30px;
}

p {
  font-size: 14px;
}
</style>
<style>
@import url(https://fonts.googleapis.com/css?family=Roboto:400,400i,500,700);
@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap);

body {
  font-family: Roboto, sans-serif;
  background: #fafafc;

}

a,
abbr,
acronym,
address,
applet,
article,
aside,
audio,
b,
big,
blockquote,
body,
canvas,
caption,
center,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
embed,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
mark,
menu,
nav,
object,
ol,
output,
p,
pre,
q,
ruby,
s,
samp,
section,
small,
span,
strike,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
tt,
u,
ul,
var,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline
}

a,
abbr,
acronym,
address,
applet,
article,
aside,
audio,
b,
big,
blockquote,
body,
canvas,
caption,
center,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
embed,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
mark,
menu,
nav,
object,
ol,
output,
p,
pre,
q,
ruby,
s,
samp,
section,
small,
span,
strike,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
tt,
u,
ul,
var,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Scroll bar*/
div::-webkit-scrollbar {
  width: 16px;
}

div::-webkit-scrollbar-track {
  background-color: transparent;
  border: 0;
}

div::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  width: 16px
}

div::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.5);
}

/* Scroll bar*/
#nav-left ::-webkit-scrollbar {
  width: 12px;
}

#nav-left ::-webkit-scrollbar-thumb {
  background-color: rgba(171, 171, 171, 0.3);
  width: 12px
}

#nav-left ::-webkit-scrollbar-thumb:hover {
  background-color: rgba(171, 171, 171, 0.3);
}


body {
  line-height: 1.4em;
}

h1 {
  margin: 0 0 1em;
  font-size: 22px;
}

a {
  color: rgba(15, 91, 194, .8);
  font-weight: 500;
  cursor: pointer;
}

a:hover {
  text-decoration: underline;
}

.calendars-container {
  padding: 0 15px;
}

.hidden {
  display: none;
}

.daterangepicker .calendar-table {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
}

.daterangepicker .calendar-table .prev,
.daterangepicker .calendar-table .next {
  background-image: url(./assets/img/triangle_right.png);
  background-position: center center;
  background-repeat: no-repeat;
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: top;
}

.daterangepicker .calendar-table .prev {
  background-image: url(./assets/img/triangle_left.png);
}

.daterangepicker .calendar-table .next span,
.daterangepicker .calendar-table .prev span {
  display: none !important;
}

.daterangepicker .calendar-table .next,
.daterangepicker .calendar-table .prev {
  opacity: .2;
}

.daterangepicker .calendar-table .available.next:hover,
.daterangepicker .calendar-table .available.prev:hover {
  opacity: 1;
}

.daterangepicker .calendar-table thead tr:first-of-type th {
  height: 56px;
}

.daterangepicker .calendar-table thead tr:last-of-type th {
  color: #3E3F42;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  line-height: 18px;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  border-bottom: 1px solid #efefef;
}

.daterangepicker .calendar-table .month select,
.daterangepicker .calendar-table .month {
  color: #3E3F42;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  text-align: center;
  -webkit-appearance: none;
}

.daterangepicker.single .calendar-table thead tr th,
.daterangepicker.single .calendar-table .month {
  height: 44px;
}

.daterangepicker.single .calendar-table .month select {
  border-radius: 3px;
  -webkit-appearance: none;
}

.clear-datepicker:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.clear-datepicker {
  -webkit-transform: translateY(-40px);
  -ms-transform: translateY(-40px);
  transform: translateY(-40px);
  float: right;
  height: 39px;
  line-height: 1;
  padding: 0 15px;
  margin-bottom: -39px;
  margin-right: -1px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 0 3px 3px 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.clear-datepicker>i {
  height: 10px;
  width: 10px;
}

.daterangepicker .calendar-table .month select {
  height: 100%;
  width: auto;
  padding: 0 8px;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.daterangepicker .calendar-table table td {
  line-height: 32px;
  height: 32px;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
}

.calendar-table .today {
  background: #ededed;
  font-weight: 500;
}

.daterangepicker .calendar-table td.available {
  color: #6B6C6F;
}

.daterangepicker .calendar-table td.available.ends {
  opacity: .8;
}

.daterangepicker .calendar-table .available:hover {
  background-color: rgba(174, 146, 95, 0.3);
}

.daterangepicker .calendar-table .in-range {
  background-color: rgba(174, 146, 95, 0.1);
}

.daterangepicker .calendar-table .start-date.active,
.daterangepicker .calendar-table .end-date.active {
  background: #ae925f;
  color: #fff;
  font-weight: 500;
}

.daterangepicker .start-date.active:hover,
.daterangepicker .end-date.active:hover {
  background: rgba(174, 146, 95, 0.85);
}

.daterangepicker .drp-buttons .btn {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 38px;
  padding: 0 18px;
  -webkit-transition: all 0.1s ease-in-out 0s;
  transition: all 0.1s ease-in-out 0s;
  font-size: 0.875rem;
  font-weight: 500;
  position: relative;
  background: #fff;
  border: 1px solid #D8DCE6;
  -webkit-box-shadow: 0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05);
  box-shadow: 0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05);
  color: #3E3F42;
  border-radius: 4px;
}

.daterangepicker .drp-buttons .applyBtn {
  background: #AE925F;
  color: #fff;
  font-weight: 500;
  border-color: #AE925F;
}

.vue-daterange-picker .form-control.reportrange-text {
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 0;
}


i.glyphicon.glyphicon-calendar.fa.fa-calendar {
  float: right;
  background-image: url(./assets/img/calendar.svg);
  background-position: center center;
  background-repeat: no-repeat;
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: top;
  position: relative;
  z-index: 1;
  margin-top: 7px;
  margin-right: 7px;
}

.form-control.reportrange-text::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  min-width: 40px;
  height: 40px;
  line-height: 1;
  border-radius: 0 4px 4px 0;
  background: linear-gradient(45deg, rgba(15, 91, 194, 0.9) 0%, rgba(58, 177, 230, 0.9) 100%);
}

.daterangepicker .calendar-table .yearselect,
.daterangepicker .calendar-table .month select {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 600;
  width: -webkit-calc(50% - 15px);
  width: calc(50% - 15px);
  padding: 0 0 0 15px;
}

.vue-daterange-picker {
  width: 100%;
}

.vue-daterange-picker .btn {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  min-width: 40px;
  height: 40px;
  line-height: 1;
  border-radius: 0 4px 4px 0;
}

.vue-daterange-picker .form-control {
  border: 2px solid #dfdbdb;
  border-radius: 4px;
  display: block;
  padding: 0 15px;
  outline: none;
  font-size: 0.875rem;
  height: 40px;
  width: 100%;
  line-height: 40px;
  -webkit-appearance: none;
}

.vue-daterange-picker .btn:focus {
  box-shadow: none;
  border: 2px solid rgba(15, 91, 194, 0.8);
}

.daterangepicker .calendar-table .end-date.active,
.daterangepicker .calendar-table .start-date.active {
  background: -webkit-linear-gradient(45deg, rgba(15, 91, 194, 0.9), rgba(58, 177, 230, 0.9));
  background: -webkit-linear-gradient(45deg, rgba(15, 91, 194, 0.9), rgba(58, 177, 230, 0.9));
  background: linear-gradient(45deg, rgba(15, 91, 194, 0.9), rgba(58, 177, 230, 0.9));
}

.daterangepicker .calendar-table .in-range {
  background: rgba(15, 91, 194, 0.05);
}

.icon-draggable {
  max-width: 48px;
  width: 100%;
  background: url(./assets/img/menu_option_fade.5ae4d3c8.svg);
  background-size: 20px 20px;
  background-position: 50%;
  background-repeat: no-repeat;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-item-align: stretch;
  -webkit-align-self: stretch;
  align-self: stretch;
  border-right: 1px solid #eaedf3;
  background-color: #fafafa;
  margin-right: 15px;
}
.agency .of-modal {
  height: calc(100% - 32px);
  top: 16px;
}
</style>